import Component from "vue-class-component"
Component.registerHooks(["beforeRouteEnter", "beforeRouteLeave", "beforeRouteUpdate"])

import "./plugins/vuetify-toast-snackbar"
import "./registerServiceWorker"
import "./global_imports"
import "./custom_directives"
import "./assets/css/style.css"

import components from "@coredination/components"
import "@coredination/components/dist/components.css"
Vue.use(components)

import Vue from "vue"
import vuetify from "./plugins/vuetify"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import * as cdn from "@coredination/components"
import i18n from "./i18n"
import "./util/vue-filters"
import * as cdnComposable from "./vue-apollo-composable"

import VuePwaInstallPlugin from "vue-pwa-install"
Vue.use(VuePwaInstallPlugin)

import VueSignaturePad from "vue-signature-pad"
Vue.use(VueSignaturePad)

import "./plugins/firebase"

import "./assets/css/style.css"

const httpEndpoint = process.env.VUE_APP_GRAPHQL_HTTP || "http://localhost:4000/"
const wsEndpoint = process.env.VUE_APP_GRAPHQL_WS || "ws://localhost:4000/"

import { provide } from 'vue'
import { DefaultApolloClient } from '@vue/apollo-composable'

// Two apollo clients - Let the old options client and new composable client coexist for now
const apolloProvider =  cdn.apollo.createProvider({ httpEndpoint, wsEndpoint })
const apolloComposableClient = cdnComposable.provideClient()

Vue.config.productionTip = false
new Vue({
    setup () {
        provide(DefaultApolloClient, apolloComposableClient)
      },
    vuetify,
    router,
    store,
    apolloProvider,
    i18n,
    render: h => h(App)
}).$mount("#app")
